import { Component, inject } from '@angular/core';
import { AuthenticationService } from '../service/auth/authentication.service';
import { ActivatedRoute } from '@angular/router';
import { map } from 'rxjs/operators';

@Component({
    selector: 'ufla-landingpage',
    templateUrl: './ufla-landingpage.component.html',
    styleUrls: [
        './ufla-landingpage.component.scss',
    ],
    standalone: false,
})
export class UflaLandingpageComponent {
    private authenticationService = inject(AuthenticationService);
    private route = inject(ActivatedRoute);

    displayLoginError$ = this.route.queryParams.pipe(
        map(params => params['error'] === 'true'),
    );

    public login() {
        this.authenticationService.login();
    }

    public async logout() {
        try {
            await this.authenticationService.logout();
        } catch (error) {
            console.error('Logout fehlgeschlagen', error);
        }
    }
}
